import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MediaType } from '@pixacare/domain';
import { ReplaySubject, Subject } from 'rxjs';
import { ImageBrokenComponent } from '../image-broken/image-broken.component';
import { ImageLoadingComponent } from '../image-loading/image-loading.component';
import { ImageOverlayComponent } from '../image-overlay/image-overlay.component';
import { VideoInfoComponent } from '../video-info/video-info.component';

@UntilDestroy()
@Component({
  selector: 'pxc-file-media-preview',
  imports: [CommonModule, ImageOverlayComponent, ImageBrokenComponent, ImageLoadingComponent, VideoInfoComponent],
  host: {
    class: 'block size-[inherit]',
  },
  templateUrl: './file-media-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileMediaPreviewComponent implements OnInit, OnDestroy {
  @Input() file: File;

  @Input() showDelete = true;

  @Output() delete = new EventEmitter<void>();

  duration$ = new Subject<number>();
  src$ = new ReplaySubject<string>(1);
  error$ = new ReplaySubject<string>(1);

  MediaType = MediaType;

  private objectUrl?: string;

  get fileType(): MediaType {
    if (this.file.type.startsWith('image/')) {
      return MediaType.IMAGE;
    } else if (this.file.type.startsWith('video/')) {
      return MediaType.VIDEO;
    }
    return null;
  }

  ngOnInit(): void {
    this.error$.pipe(untilDestroyed(this)).subscribe((error) => {
      console.error('Error loading media', error);
    });

    if (!this.file) {
      this.error$.next('Missing file');
      return;
    }

    // An object URL is a cheap blob reference. Reading the file into a base64 data
    // URL instead would load and encode the whole file on the main thread, freezing
    // the UI while a large video (mp4) is turned into a giant string.
    this.objectUrl = URL.createObjectURL(this.file);
    this.src$.next(this.objectUrl);
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
